import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import RoomsV1 from './container';
import { RoomsV2 } from './v2';

type RoomsVersionProps = {
  language: string;
};

export const RoomsVersion: FC<RoomsVersionProps> = ({ language }) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <RoomsV2 language={language} />;
  return <RoomsV1 language={language} />;
};
